import { render, staticRenderFns } from "./CreateRewardSuccess.vue?vue&type=template&id=265722e6&scoped=true&"
import script from "./CreateRewardSuccess.vue?vue&type=script&lang=js&"
export * from "./CreateRewardSuccess.vue?vue&type=script&lang=js&"
import style0 from "./CreateRewardSuccess.vue?vue&type=style&index=0&id=265722e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265722e6",
  null
  
)

export default component.exports